import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  ErrorDialogData,
  ErrorDialogComponent,
} from "@components/modals/error-dialog/error-dialog.component";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ErrorDialogService {
  constructor(private dialog: MatDialog) {}

  showError(message: string, title?: string): Observable<boolean> {
    return this.openDialog({
      title: title || "Error",
      message,
      icon: "error",
      confirmButtonText: "OK",
    });
  }

  showWarning(message: string, title?: string): Observable<boolean> {
    return this.openDialog({
      title: title || "Warning",
      message,
      icon: "warning",
      confirmButtonText: "OK",
    });
  }

  showInfo(message: string, title?: string): Observable<boolean> {
    return this.openDialog({
      title: title || "Information",
      message,
      icon: "info",
      confirmButtonText: "OK",
    });
  }

  showOrganizationAccessDenied(message: string): Observable<boolean> {
    return this.openDialog({
      title: "Access Denied",
      message,
      icon: "block",
      confirmButtonText: "Return to Login",
      details:
        "Please contact your administrator if you believe this is an error.",
    });
  }

  showConfirmation(message: string, title?: string): Observable<boolean> {
    return this.openDialog({
      title: title || "Confirm",
      message,
      icon: "help",
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
    });
  }

  showCustom(data: ErrorDialogData): Observable<boolean> {
    return this.openDialog(data);
  }

  private openDialog(data: ErrorDialogData): Observable<boolean> {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: "400px",
      disableClose: true,
      data,
    });

    return dialogRef.afterClosed();
  }

  showGenericError(technicalDetails?: string): Observable<boolean> {
    return this.openDialog({
      title: "Something Went Wrong",
      message:
        "An unexpected error occurred. Please try again or contact your administrator for assistance.",
      details: technicalDetails,
      icon: "error",
      confirmButtonText: "OK",
    });
  }

  showAccountError(message: string): Observable<boolean> {
    return this.openDialog({
      title: "Account Error",
      message,
      icon: "error",
      confirmButtonText: "Return to Login",
      details:
        "Please contact your administrator if you believe this is an error.",
    });
  }

  showApiError(endpoint?: string, statusCode?: number): Observable<boolean> {
    const details = endpoint
      ? `Endpoint: ${endpoint}${statusCode ? ` (Status: ${statusCode})` : ""}`
      : undefined;

    return this.openDialog({
      title: "Connection Error",
      message:
        "We couldn't complete your request. Please check your connection and try again.",
      details,
      icon: "error",
      confirmButtonText: "OK",
    });
  }
}
